module.exports = __webpack_public_path__ + "img/star2.74bad8b4.png";